// FRISCO feature flags.
//
// Feature-level flags live here, separate from code-level constants in
// Ateam-BI/Frisco/Constants.tsx. Each flag lists the stages where the feature
// is enabled; a stage absent from the list (e.g. prod) keeps the feature
// hidden. Encryption and Fintella onboarding are beta/dev-only until promoted.
type Stage = 'dev' | 'alpha' | 'beta' | 'gamma' | 'prod';

export const FRISCO_FEATURE_FLAGS: Readonly<Record<string, readonly Stage[]>> = {
    ENCRYPTION: ['beta', 'dev'],
    FINTELLA: ['beta', 'dev'],
};

// Returns true when the given feature is enabled for the given stage. Unknown
// flags or stages are treated as disabled (safe default: hidden).
export const isFriscoFeatureEnabled = (
    feature: keyof typeof FRISCO_FEATURE_FLAGS | string,
    stage?: string | null
): boolean => {
    const stages = FRISCO_FEATURE_FLAGS[feature as keyof typeof FRISCO_FEATURE_FLAGS];
    return !!stage && !!stages && stages.includes(stage as Stage);
};
